import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Box, Typography, Tooltip } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import TableComponent from '../../../Components/TableComponent/TableComponent';
import { SnackBarComponent } from '../../../Components/snackBar/snackBar';
import { LoadingSpinner } from '../../../Components/spinner/spinner';
import { API_BASE_URL } from '../../../config';
import { useTranslation } from 'react-i18next';

export const StaffManualVideos = () => { 
  const { t } = useTranslation();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('info');

  const columns = [
    { id: 'slNo', field: 'slNo', headerName: t('manualVideos.slNo'), width: 50 },
    { id: 'subject', field: 'subject', headerName: t('manualVideos.subject'), width: 300 },
    {
      id: 'viewDetails',
      field: 'viewDetails',
      headerName: t('manualVideos.view'),
      width: 120,
      renderCell: (params) => (
        <Tooltip title={t('manualVideos.viewDetails')}>
          <a href={params.value} target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2' }}>
            <VisibilityIcon />
          </a>
        </Tooltip>
      ),
    },
  ];

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/home-notification/staff-manaual-vid/`)
      .then((response) => {
        const apiData = response.data.map((item, index) => ({
          id: item.id,
          slNo: index + 1,
          subject: item.subject,
          viewDetails: item.link,
        }));
        setRows(apiData);
        setSnackbarMessage(t('manualVideos.successMessage'));
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Failed to fetch Manuals and videos:', error);
        setSnackbarMessage(t('manualVideos.errorMessage'));
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
        setLoading(false);
      });
  }, [t]);

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  if (loading) {
    return <LoadingSpinner size={30} />;
  }

  return (
    <Box
      sx={{
        width: '100%',
        mt: 8,
        mb: 1,
        borderRadius: 2,
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        backgroundColor: '#fff',
      }}
    >
      <Box display="flex" justifyContent="center" backgroundColor="rgba(195, 234, 203, 0.1)" mb={2}>
        <Typography variant="h4" component="h1" align="center" sx={{ fontWeight: 'bold' }}>
          {t('manualVideos.heading')}
        </Typography>
      </Box>

      <TableComponent
        columns={columns}
        rows={rows}
        manageColumnStatus={true}
        enableSort={true}
        sx={{
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: '#1976d2',
            color: '#fff',
            fontWeight: 'bold',
          },
        }}
      />

      <SnackBarComponent
        open={snackbarOpen}
        message={snackbarMessage}
        severity={snackbarSeverity}
        onClose={handleSnackbarClose}
      />
    </Box>
  );
};
